import React from 'react';

import { ApplicantDetailsForm } from '../../Form/Forms';

export default () => (
  <div className="form-content">
    <ApplicantDetailsForm />
  </div>
);
